export default "__VITE_ASSET__0194ac44__"